import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Link from 'next/link';
import Styles from './styles.js';
import React from 'react';

const Benefits = ({ heading, card1Title, card2title, card3Title, card4Title, card5Title, card6Title, bg, spacing }) => {
  return (
    <div>
      <div className="container-fluid   px-lg-0 ">
        <HeadingSection spacing={spacing} title={heading} bgcolor="white" />

        <div className="lg:container mx-auto px-xl-5 pt-4 ">
          <div className="grid lg:grid-cols-3 lg:gap-4">
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="card bg-transparent border-0">
                <div className="  text-center ">
                  <p
                    className="fs-24-30 fontWeight mb-lg-4 mb-3   "
                    style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                    {card1Title}
                  </p>
                </div>

                <img
                  loading="lazy"
                  src="/static/images/landingPages/ForRenters/Renter.png"
                  className=" img img-fluid rounded-0 card-img-top"
                  alt="..."
                />

                <div className="card-body p-0  pb-2">
                  <div
                    className="card-title d-flex flex-lg-row
                          flex-column justify-content-between text-center mt-3 mb-0 mb-md-4 pb-0 pb-md-3 pt-2"
                    style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                    <p className="fs-18-27 fw-400">
                      Sign up once and curate your profile for all your applications and inquiries. Witness your renter
                      profile evovle with time, making it the best reference for landlords
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="card bg-transparent border-0">
                <div className="  text-center">
                  <p
                    className="fs-24-30 fontWeight mb-3 mb-lg-4  "
                    style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                    {card2title}
                  </p>
                </div>

                <img
                  loading="lazy"
                  src="/static/images/landingPages/ForRenters/onlinebooking.png"
                  className=" img img-fluid rounded-0 card-img-top"
                  alt="..."
                />

                <div className="card-body p-0  pb-2">
                  <div
                    className="card-title d-flex flex-lg-row
                      flex-column justify-content-between text-center mt-3 mb-0 mb-md-4 pb-0 pb-md-3 pt-2"
                    style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                    <p className="fs-18-27 fw-400">
                      No more paperwork. Our proprietary process enables booking long term homes as easy as booking a
                      hotel
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="card bg-transparent border-0">
                <div className="  text-center">
                  <p
                    className="fs-24-30 fontWeight mb-lg-4 mb-3  "
                    style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                    {card3Title}
                  </p>
                </div>

                <img
                  loading="lazy"
                  src="/static/images/landingPages/ForRenters/onlinecommunity.png"
                  className=" img img-fluid rounded-0 card-img-top"
                  alt="..."
                />

                <div className="card-body p-0  pb-2">
                  <div
                    className="card-title d-flex flex-lg-row
                         flex-column justify-content-between  text-center
                         mt-3 mb-4 pb-3 pt-2"
                    style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                    <p className="fs-18-27 fw-400">
                      Get access to the community app, interact and get to know hundreds of young professionals around
                      you
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6  ">
              <div className="card bg-transparent border-0">
                <div className="  text-center">
                  <p
                    className="fs-24-30 fontWeight mb-lg-4 mb-3  "
                    style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                    {card4Title}
                  </p>
                </div>

                <img
                  loading="lazy"
                  src="/static/images/landingPages/ForRenters/Screening.png"
                  className=" img img-fluid rounded-0 card-img-top"
                  alt="..."
                />

                <div className="card-body p-0  pb-2">
                  <div
                    className="card-title d-flex flex-lg-row
                      flex-column justify-content-between text-center mt-3 mb-0 mb-md-4 pb-0 pb-md-3 pt-2"
                    style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                    <p className="fs-18-27 fw-400">
                      New to the country and do not have a credit score? We provide landlords with integrated screening
                      technology which goes beyond local scores
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6  ">
              <div className="card bg-transparent border-0">
                <div className="  text-center">
                  <p
                    className="fs-24-30 fontWeight mb-lg-4 mb-3  "
                    style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                    {card5Title}
                  </p>
                </div>

                <img
                  loading="lazy"
                  src="/static/images/landingPages/ForRenters/Portal.png"
                  className=" img img-fluid rounded-0 card-img-top"
                  alt="..."
                />

                <div className="card-body p-0  pb-2">
                  <div
                    className="card-title d-flex flex-lg-row
                         flex-column justify-content-between text-center
                         mt-3 mb-4 pb-3 pt-2">
                    <p className="fs-18-27 fw-400 " style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                      Simple yet powerful Renter's Portal to raise and track all your requests and information from the
                      respective landlords
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6  ">
              <div className="card bg-transparent border-0">
                <div className="  text-center">
                  <p
                    className="fs-24-30 fontWeight mb-lg-4 mb-3  "
                    style={{ fontFamily: 'josefin Sans', color: '#1b1b1b' }}>
                    {card6Title}
                  </p>
                </div>

                <img
                  loading="lazy"
                  src="/static/images/landingPages/ForRenters/noscam.png"
                  className=" img img-fluid rounded-0 card-img-top"
                  alt="..."
                />

                <div className="card-body p-0  pb-2">
                  <div
                    className="card-title d-flex flex-lg-row
                         flex-column justify-content-between  text-center
                         mt-3 mb-4 pb-3 pt-2"
                    style={{ fontFamily: 'josefin Sans', color: '#5e5e5e' }}>
                    <p className="fs-18-27 fw-400">
                      All landlords signed up with SoulRooms are verified ensuring what you see online is what you
                      actually get when you move in.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Styles />
    </div>
  );
};

export default Benefits;
